require("core-js/modules/es6.regexp.search");
/**
 * Created by commyfeng on 2017/5/16.
 */

var cgiPath = '//node.video.qq.com/x/vip/quick_cgi/autovue/welfare2018/';
var isTestEnv = location.search.indexOf('env=test') >= 0;
if (window.previewPid) {
  window.DataRequest = function (reqName) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      $.ajax($.extend({
        url: cgiPath + reqName,
        dataType: 'jsonp',
        data: {
          _param: JSON.stringify(param),
          env: isTestEnv ? 'test' : 'online'
        },
        success: function success(res) {
          if (res.code === 0) {
            resolve(res.data);
          } else {
            reject(new Error("\u8BF7\u6C42".concat(reqName, "\u5931\u8D25\uFF1A") + res.msg));
          }
        },
        error: function error(err) {
          reject(err);
        }
      }));
    });
  };
} else {
  window.DataRequest = function (reqName) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var baseUrl = process.env.NODE_ENV === 'development' || window.__INITIAL_STATE__ || location.href.indexOf('film.qq.com/x/') > 0 ? 'cgi/' : cgiPath;
    return new Promise(function (resolve, reject) {
      $.ajax({
        dataType: 'json',
        url: baseUrl + reqName,
        type: 'GET',
        xhrFields: {
          withCredentials: true
        },
        data: {
          _param: JSON.stringify(param),
          env: isTestEnv ? 'test' : 'online',
          _: Date.now()
        },
        success: function success(res) {
          if (res.code === 0) {
            resolve(res.data);
          } else {
            reject(new Error("\u8BF7\u6C42".concat(reqName, "\u5931\u8D25\uFF1A") + res.msg));
          }
        },
        error: function error(err) {
          reject(err);
        }
      });
    });
  };
}